/** Exception queue: list, resolve, summary. */
import { endpoints } from '@/config/env';
import type { ExceptionAction, ExceptionRecord, ExceptionsSummary, Page } from '@/types';
import { request } from './client';

export function fetchExceptions(
  page = 0,
  size = 20,
  range: { from?: string; to?: string } = {},
  signal?: AbortSignal,
): Promise<Page<ExceptionRecord> | null> {
  return request<Page<ExceptionRecord> | null>(endpoints.exceptions(page, size, range), { signal });
}

export function fetchExceptionsSummary(
  range: { from?: string; to?: string } = {},
  signal?: AbortSignal,
): Promise<ExceptionsSummary | null> {
  return request<ExceptionsSummary | null>(endpoints.exceptionsSummary(range), { signal });
}

export function resolveException(
  exceptionId: string,
  resolutionNote: string,
  actionTaken: ExceptionAction,
): Promise<unknown> {
  return request(endpoints.exceptionResolve(exceptionId), {
    method: 'PUT',
    body: { resolutionNote, actionTaken },
  });
}
